import {Injectable} from "@angular/core";
import {HandlerError, HttpErrorHandlerService} from "../../../core/services/http-error-handler.service";
import {HttpClient} from "@angular/common/http";
import { environment } from "@env/environment";
import {catchError, Observable} from "rxjs";
import {BaseResponse} from "../../../core/models/base-response";
import {ListaPessoa} from "../models/lista-pessoa";
import {PessoaDetalhes} from "../models/pessoa-detalhes";
import {NovaPessoa} from "../models/nova-pessoa";
import {Cliente} from "../cliente/models/cliente";
import {ClienteDetalhes} from "../../../core/models/cliente-detalhes";

@Injectable({
  providedIn: 'root'
})
export class ClienteService {
  private handlerErro: HandlerError;

  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handlerErro = httpErrorHandler.createHandleError(`ClienteService`);
  }

  baseUrl = environment.apiUrl;

  selecionarLista(): Observable<BaseResponse<ListaPessoa> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<ListaPessoa>>(`${this.baseUrl}/Cliente`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarLista')));
  }

  selecionarListaAtivos(): Observable<BaseResponse<Cliente[]> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<Cliente[]>>(`${this.baseUrl}/Cliente/Ativos`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarLista')));
  }

  selecionarListaPorResponsavel(): Observable<BaseResponse<Cliente[]> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<ListaPessoa>>(`${this.baseUrl}/Cliente/ListarClientesPorOrigemPorResponsavel`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarListaPorResponsavel')));
  }

  selecionarListaPorOrigem(): Observable<BaseResponse<Cliente[]> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<ListaPessoa>>(`${this.baseUrl}/Cliente/ListarClientesPorOrigem`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarListaPorOrigem')));
  }


  selecionarPorId(id: number): Observable<BaseResponse<PessoaDetalhes> | BaseResponse<any> >{
    return this.http
      .get<BaseResponse<PessoaDetalhes>>(`${this.baseUrl}/Cliente/${id}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarPorId')));
  }

  selecionarPorTipoDocumentoeDocumento(tipoDocumento: number, documento: string): Observable<BaseResponse<PessoaDetalhes> | BaseResponse<any> >{
    return this.http
      .get<BaseResponse<PessoaDetalhes>>(`${this.baseUrl}/Cliente/BuscarPorDocumento/${tipoDocumento}/${documento}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarPorTipoDocumentodeDocumento')));
  }

  alterar(request: PessoaDetalhes): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .put<BaseResponse<boolean>>(`${this.baseUrl}/Cliente`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>(`alterar`)));
  }

  adicionar(request: NovaPessoa): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .post<BaseResponse<boolean>>(`${this.baseUrl}/Cliente`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>(`adicionar`)));
  }

  adicionarNovoCliente(request: Cliente): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .post<BaseResponse<boolean>>(`${this.baseUrl}/Cliente/AdicionarCliente`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>(`adicionarNovoCliente`)));
  }

  desativar(id: number): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
          .delete<BaseResponse<boolean>>(`${this.baseUrl}/Cliente/${id}`)
          .pipe(catchError(this.handlerErro<BaseResponse<any>>(`desativar`)));
  }

  buscarDetalhesPorId(id: number): Observable<BaseResponse<ClienteDetalhes> | BaseResponse<any>> {
    return this.http
      .get<BaseResponse<ClienteDetalhes>>(`${this.baseUrl}/Cliente/BuscarCRMPorId/${id}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>(`buscarDetalhesPorId`)));
  }
}
